import ClaimingMixedRequest from "./ClaimingMixedRequest";

export default ClaimingMixedRequest;